import type { AdminSource } from "@contract-manager/shared";
import { useI18n } from "../i18n/I18n";
import type { MessageKey } from "../i18n/messages";

/**
 * Why somebody is an administrator, as a tag.
 *
 * The two kinds look different on purpose: one on the allowlist cannot be
 * demoted from the screen, one on the admin team can, and somebody about to
 * take a person off the admin team should be able to tell which they have.
 */
interface TagStyle {
  readonly labelKey: MessageKey;
  readonly tone: string;
}

const SOURCE_TAGS: Record<AdminSource, TagStyle> = {
  ALLOWLIST: { labelKey: "admin.allowlist", tone: "--warning" },
  ADMIN_TEAM: { labelKey: "admin.team", tone: "--info" },
};

export function AdminSourceBadges({
  sources,
}: {
  sources: readonly AdminSource[];
}) {
  return (
    <>
      {sources.map((source) => (
        <AdminTag key={source} {...SOURCE_TAGS[source]} />
      ))}
    </>
  );
}

/** Marks the team whose members are administrators. */
export function AdminTeamBadge() {
  return <AdminTag {...SOURCE_TAGS.ADMIN_TEAM} />;
}

function AdminTag({ labelKey, tone }: TagStyle) {
  const { t } = useI18n();
  return (
    <span className={`ds-tag --small ${tone}`}>
      <span>{t(labelKey)}</span>
    </span>
  );
}
